import React, { useEffect, useRef, useState } from "react"
import { message, Space, Tooltip } from "antd"

import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import CB1 from "src/components/Modal/CB1"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import Notice from "src/components/Notice"
import dayjs from "dayjs"

import STORAGE, { getStorage } from "src/lib/storage"
import WarehouseService from "src/services/WarehouseService"
import ViewDetailModal from "../../SimWarehouse/Modal/ViewDetailModal"
import RejectModal from "../../Modal/RejectModal"
import ModalCreate from "../../SimWarehouse/Modal/ModalCreate"
import ModalCreateData from "../Modal/ModalCreateData"
import ModalDetailData from "../../Modal/ModalDetailData"
import FilterData from "./FilterData"
import { filter } from "lodash"

const MODAL_ACTION = {
  view: { type: "view", title: "Xem thông tin khách hàng" },
  edit: { type: "edit", title: "Chỉnh sửa thông tin khách hàng" },
}

function ListDataRequest(props) {
  const [dataSource, setDataSource] = useState([])
  const [dataSelected, setDataSelected] = useState([])
  const [isModalAction, setIsModalAction] = useState({})
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
  const [searchTerm, setSearchTerm] = useState("")
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [isViewModalOpen, setIsViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [openRejectModal, setOpenRejectModal] = useState(false)
  const [summary, setSummary] = useState({})
  const [rejectReason, setRejectReason] = useState("")
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false)
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [refresh, setRefresh] = useState(false)
  const handleReject = record => {
    setSelectedRecord(record)
    setOpenRejectModal(true)
  }
  // console.log(props, "props")
  // console.log(props.filter, "props stfft")
  // console.log(props.setFilter, "props t")
  // const onSearch = () => {
  //   setSearchTerm(inputSearchRef.current)
  // }

  // const handleAction = (type, customerId) => {
  //   setIsModalAction({ type, customerId })

  // }

  const handleApprove = record => {
    CB1({
      title: `Bạn có chắc chắn muốn <strong>DUYỆT</strong> lô <strong>${record.batch_code}</strong>?`,
      icon: "approval",
      okText: "Duyệt",
      onOk: async close => {
        try {
          const res = await WarehouseService.updateDataBrowse(record.ID)
          if (res?.message?.toLowerCase().includes("thành công")) {
            message.success(" Duyệt phiếu nhập kho nhập kho thành công!")
            fetchData(props.status)
          } else {
            message.error("Duyệt phiếu nhập kho nhập kho thất bại.")
          }
        } catch (err) {
          message.error("Lỗi khi duyệt phiếu nhập kho nhập kho.")
        }
        close()
      },
    })
  }

  const confirmReject = async () => {
    try {
      const res = await WarehouseService.updateDataRefuse(selectedRecord.ID, {
        note: rejectReason,
      })
      if (res?.message?.toLowerCase().includes("thành công")) {
        message.success("Từ chối phiếu nhập kho nhập kho thành công!")
        fetchData(props.status)
      } else {
        message.error("Từ chối phiếu nhập kho nhập kho thất bại.")
      }
    } catch (err) {
      message.error("Lỗi khi từ chối phiếu nhập kho nhập kho.")
    } finally {
      setOpenRejectModal(false)
    }
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setDataSelected(selectedRows)
    },
  }
  const handleDelete = record => {
    if (!record || !record.ID) {
      message.error("Không tìm thấy dữ liệu để xóa.");
      return;
    }

    CB1({
      title: `Bạn có chắc chắn muốn xoá <strong>${record.batch_code}</strong> không?`,
      icon: "trashRed",
      okText: "Đồng ý",
      onOk: close => handleConfirmDelete(record, close),
    });
  };

  const handleConfirmDelete = async (record, close) => {
    try {
      const response = await WarehouseService.deleteData({
        ids: [record.ID],
      });

      if (isDeleteSuccess(response)) {
        handleDeleteSuccess(record);
      } else {
        message.error("Xóa dữ liệu thất bại.");
      }
    } catch (error) {
      message.error("Lỗi khi xóa dữ liệu.");
    }

    close();
  };

  const isDeleteSuccess = response =>
    response?.message?.toLowerCase().includes("thành công");

  const handleDeleteSuccess = record => {
    message.success("Xóa phiếu nhập kho nhập kho thành công!");

    fetchData(props.status);

    setDataSource(prev =>
      prev.filter(item => item.id !== record.ID)
    );

    setDataSelected([]);
  };

  const handleAction = (actionType, ID, record) => {
    switch (actionType) {
      case "view":
        setSelectedRecord(record);
        setIsViewModalOpen(true);
        return;

      case "edit":
        setSelectedRecord(record);
        setIsUpdateModalOpen(true);
        return;

      case "delete":
        handleDelete(record);
        return;

      default:
        return;
    }
  };

  // useEffect(() => {
  //   fetchData(props.status,filter, props.type, keyword)
  // }, [refresh, pagination.current, pagination.pageSize, filter, keyword])

  useEffect(() => {
    fetchData(props.status, filter, props.type, keyword)
  }, [pagination.current, pagination.pageSize])

  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(props.status, filter, props.type, keyword)
      }
    }
  }, [props.refresh, filter, keyword, props.status, refresh])

  const fetchData = async (status, filter, type, keyword) => {
    setLoading(true)
    try {
      const response = await WarehouseService.listData({
        page: pagination.current,
        per_page: pagination.pageSize,
        filter: {
          type: status,
          ...filter,
        },
        keyword,
      }) // Thêm tham số cho API
      const users = response?.success?.data || []
      const total = response?.success?.total || users.length
      const current = response.current_page
      const perPage = response.per_page
      setPagination({
        ...pagination,
        total,
      })
      setSummary({
        totalAccounts: total,
      })
      props.setFilter(filter)
      const dataSource = users.map((item, index) => ({
        ...item,
        total_price: Number(item.total_amount || 0).toLocaleString("en-US"),
        total_discount: Number(item.total_discord || 0).toLocaleString("en-US"),
        // discount_value: Number(item.discount_value || 0).toLocaleString(
        //   "en-US",
        // ),
      }))
      setDataSource(dataSource || [])
    } catch (error) {
      message.error("Lỗi khi tải dữ liệu.")
    } finally {
      setLoading(false)
    }
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }
  // Cột bảng phiếu nhập kho
  const columns = [
    // {
    //   title: "STT",
    //   dataIndex: "index",
    //   key: "index",
    //   render: (_, record, i) => {
    //     return <>{i + 1}</>
    //   },
    // },
    {
      title: "Mã lô nhập",
      dataIndex: "batch_code",
      key: "batch_code",
      align: "center",
    },
    {
      title: "Nhà cung cấp",
      dataIndex: "supplier",
      key: "supplier",
      align: "center",
      render: supplier => supplier?.name || "",
    },
    {
      title: "Nhà mạng",
      dataIndex: "network",
      key: "network",
      align: "center",
      render: network => network?.name || "",
    },
    {
      title: "Quốc gia",
      dataIndex: "country",
      key: "country",
      align: "center",
      render: country => country?.title || "",
    },
    {
      title: "Dung lượng Data",
      dataIndex: "total_initial_data",
      key: "total_initial_data",
      align: "center",
    },
    {
      title: "Đơn giá Data",
      dataIndex: "unit_price",
      key: "unit_price",
      render: text => Number(text).toLocaleString(),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền",
      dataIndex: "total_price",
      key: "total_price",
      // render: text => Number(text).toLocaleString("en-US"),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Loại chiết khấu",
      dataIndex: "discount_type",
      key: "discount_type",
      align: "center",
      render: text => {
        if (text === "percent") {
          return "Chiết khấu %"
        } else if (text === "fixed") {
          return "Chiết khấu số tiền"
        }
        return text
      },
    },
    {
      title: "Chiết khấu",
      dataIndex: "discount",
      key: "discount",
      align: "center",
      render: text => Number(text).toLocaleString(),
    },
    {
      title: "Tiền sau chiết khấu",
      dataIndex: "total_discount",
      key: "total_discount",
      // render: text => Number(text).toLocaleString("en-US"),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Ngày nhập kho",
      dataIndex: "approved_at",
      align: "center",
      key: "approved_at",
      render: text => {
        return dayjs(text).isValid() ? dayjs(text).format("DD-MM-YYYY") : ""
      },
    },
    {
      title: "Người duyệt",
      dataIndex: "approved",
      key: "approved",
      align: "center",
      render: approved => approved?.fullname || "",
    },
    {
      title: "Trạng thái",
      dataIndex: "type",
      key: "type",
      align: "center",
      render: type => {
        const status = Number(type)
        let text = "Chờ duyệt"
        let color = "#fa8c16"

        if (status === 1) {
          text = "Đã duyệt"
          color = "green"
        } else if (status === 2) {
          text = "Từ chối"
          color = "red" // Cam
        }

        return <span style={{ color, fontWeight: "bold" }}>{text}</span>
      },
    },

    {
      title: <Tooltip title="Hành động">_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (_, record) => {
        const isFinalized = record.type === "1" || record.type === "2"
        const actions = []

        if (permissions.includes("warehouse.data.detail")) {
          actions.push(
            <div
              key="view"
              onClick={() => {
                handleAction("view", record.ID, record)
              }}
            >
              <IconBase name="eye" />
              <span>Xem chi tiết</span>
            </div>,
          )
        }

        if (!isFinalized) {
          if (permissions.includes("warehouse.data.update")) {
            actions.push(
              <div
                key="edit"
                onClick={() => {
                  handleAction("edit", record.ID, record)
                }}
              >
                <IconBase name="edit" />
                <span>Sửa</span>
              </div>,
            )
          }

          if (permissions.includes("warehouse.data.delete")) {
            actions.push(
              <div
                key="delete"
                onClick={() => {
                  handleAction("delete", record.id, record)
                }}
              >
                <IconBase name="delete" />
                <span>Xóa</span>
              </div>,
            )
          }

          if (permissions.includes("warehouse.data.browse")) {
            actions.push(
              <div key="approve" onClick={() => handleApprove(record)}>
                <IconBase name="approval" />
                <span>Duyệt</span>
              </div>,
            )
          }

          if (permissions.includes("warehouse.data.refuse")) {
            actions.push(
              <div key="reject" onClick={() => handleReject(record)}>
                <IconBase name="cancelApproval" />
                <span>Từ chối</span>
              </div>,
            )
          }
        }

        return <PopupAction>{actions}</PopupAction>
      },
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  return (
    <div>
      {!!dataSelected.length && (
        <ButtonCircle
          style={{ marginRight: "10px", marginBottom: "10px" }}
          title={`Xóa ${dataSelected.length} hàng đã chọn`}
          iconName="delete-outline"
          onClick={() => {
            if (dataSelected.length === 0) {
              message.warning("Vui lòng chọn ít nhất một bản ghi để xóa.")
              return
            }

            CB1({
              title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
              icon: "trashRed",
              okText: "Đồng ý",
              onOk: async close => {
                const idsToDelete = dataSelected.map(item => item.ID)
                try {
                  const response = await WarehouseService.deleteData({
                    ids: idsToDelete,
                  })

                  // Dùng message nếu không có field "success"
                  if (response?.message?.toLowerCase().includes("thành công")) {
                    message.success("Xóa dữ liệu thành công!")
                    fetchData(props.status) // Refresh lại danh sách
                    setDataSelected([]) // Reset selected nếu cần
                  } else {
                    message.error("Xóa dữ liệu thất bại.")
                  }
                } catch (error) {
                  console.error("Lỗi khi xóa:", error)
                  message.error("Lỗi khi xóa dữ liệu.")
                }
                close()
              },
            })
          }}
        />
      )}
      <FilterData
        filter={filter}
        setFilter={setFilter}
        setKeyword={setKeyword}
      />
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>
      <TableCustom
        rowKey="ID"
        showPagination={true}
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        isPrimary
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        bordered
        scroll={{ x: "max-content" }}
      />
      {isViewModalOpen && (
        <ModalDetailData
          open={isViewModalOpen}
          onCancel={() => setIsViewModalOpen(false)}
          record={selectedRecord}
          refresh={setRefresh}
        />
      )}
      {isUpdateModalOpen && (
        <ModalCreateData
          open={isUpdateModalOpen}
          onCancel={() => setIsUpdateModalOpen(false)}
          record={selectedRecord}
          onOk={() => {
            setIsUpdateModalOpen(false)
            setRefresh(prev => !prev)
          }}
        />
      )}
      <RejectModal
        open={openRejectModal}
        onCancel={() => setOpenRejectModal(false)}
        onConfirm={confirmReject}
        setRejectReason={setRejectReason}
      />
      {/* <ModalCreateData
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSubmit={(values) => {
          setIsModalOpen(false);
          // fetchUsers();
        }}
      /> */}
    </div>
  )
}

export default ListDataRequest
